import React, { memo, useCallback, useMemo } from 'react';
import './MusicianCard.css';
import { useNavigate } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';

function StudioCard({ studio }) {
  const navigate = useNavigate();

  // Mémorisation du callback pour éviter les re-créations inutiles
  const goToProfile = useCallback(() => {
    navigate(`/studios/${studio.id}`);
  }, [navigate, studio.id]);

  // Mémorisation de l'URL de l'image pour éviter les recalculs
  const imageSrc = useMemo(() => 
    studio.imageURL ? `/images/studios/${studio.imageURL}` : '/default-studio.png',
    [studio.imageURL]
  );

  return (
    <div className="musician-card">
      <OptimizedImage
        src={imageSrc}
        alt={studio.name}
        className="musician-image"
        fallback="/default-studio.png"
      />
      <h3>{studio.name}</h3>
      <p><strong>Ville :</strong> {studio.city}</p>
      {studio.description && <p className="bio">{studio.description}</p>}

      <button className="profile-button" onClick={goToProfile}>
        Voir le studio
      </button>
    </div>
  );
}

export default memo(StudioCard);